import React from "react";
import Meta from "./../components/Meta";
import SettingsSection from "./../components/SettingsSection";
import { useRouter } from "./../util/router";
import { requireAuth } from "./../util/auth";
import { useTranslation } from 'react-i18next';

function SettingsPage(props) {
  const router = useRouter();
  const { t } = useTranslation();
  return (
    <>
      <Meta title={t("meta.settings.title")} />
      <SettingsSection
        bgColor="default"
        size="medium"
        bgImage=""
        bgImageOpacity={1}
        section={router.query.section}
        key={router.query.section}
      />
    </>
  );
}

export default requireAuth(SettingsPage);
